module.exports = __webpack_public_path__ + "img/validator_record.28c2e740.png";